<app-type-oui-non-inform-complementaire
[uid]="getUid()"
[parentForm]="parentForm"

[disabled]="disabled"
[informComplementaire]="fnSimpleInitial.informComplementaire"
></app-type-oui-non-inform-complementaire>